export const WHATSAPP_NUMBER = "40732873176";
export const PHONE_DISPLAY = "+40 (732) 873 176";
export const PHONE_TEL = "+40732873176";

export const products = [
  {
    id: "p1",
    slug: "pachet-promotional-xxl-15l",
    title: "Pachet Promoțional XXL: 15L Detergent Rufe (3x5L)",
    short: "15L Detergent Rufe Profesional",
    price: 139.99,
    oldPrice: 249,
    discount: 44,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/hbhgweuv_IMG-20260822-WA0005.jpg",
    badge: "Cel mai bun preț",
    highlights: [
      "Peste 300 de spălări",
      "Transport gratuit oriunde în România",
      "3 arome distincte: Lavandă · Glamour · Pădure Alpină",
      "Formulă concentrată profesională",
    ],
    description:
      "Pachetul nostru XXL este alegerea perfectă pentru familiile care vor să economisească pe termen lung. Conține 15 litri de detergent de rufe profesional în 3 arome distincte (Lavandă, Glamour, Pădure Alpină), livrați direct la ușa ta absolut gratuit. Ajunge pentru peste 300 de spălări. Formulă fabricată în România conform standardelor europene.",
  },
  {
    id: "p2",
    slug: "pachet-2x5l-detergent-balsam",
    title: "Pachet 2×5L Detergent de Rufe + 5L Balsam de Rufe",
    short: "10L Detergent + 5L Balsam – Ofertă Imbatabilă",
    price: 139.99,
    oldPrice: 189,
    discount: 26,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/xajen14r_IMG-20260918-WA0006.jpg",
    badge: "Ofertă imbatabilă",
    highlights: [
      "Curățenie completă + prospețime de durată",
      "10L detergent + 5L balsam",
      "Transport gratuit",
      "Ideal pentru familii numeroase",
    ],
    description:
      "Pachet complet pentru cei care vor și curățenie profundă și prospețime persistentă. Două bidoane de 5 litri detergent de rufe alături de 5 litri balsam premium fac din această ofertă alegerea cea mai economică. Rufele tale vor mirosi fantastic timp îndelungat, iar petele cele mai dificile dispar de la prima spălare.",
  },
  {
    id: "p7",
    slug: "pachet-3x5l-detergent-5l-balsam-cadouri",
    title: "Pachet 3×5L Detergenți + 5L Balsam + 2 CADOURI",
    short: "15L Detergent + 5L Balsam + Praf de curățat aragazul + Calgon",
    price: 199,
    oldPrice: 329,
    discount: 40,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/o7khx84z_IMG-20260913-WA0015.jpg",
    badge: "Cel mai complet",
    highlights: [
      "3 bidoane detergent (Glamour + Lavandă + Pădure Alpină) - 15L",
      "5L Balsam premium Leno Blue Kassic",
      "CADOU: 150g Praf de curățat aragazul + 150g Calgon",
      "Transport gratuit oriunde în România",
    ],
    description:
      "Cel mai complet pachet Detereco-Green. Include 3 bidoane de detergent lichid concentrat (parfumuri Glamour, Lavandă, Pădure Alpină) — 15 litri în total — plus 5 litri de balsam premium Leno Blue Kassic pentru catifelare și prospețime de durată. Bonus, primești 2 cadouri: praf de curățat aragazul și Calgon anticalcar pentru mașina de spălat, câte 150g fiecare. Peste 400 de spălări din același pachet, la preț imbatabil, cu transport GRATUIT.",
  },
  {
    id: "p16",
    slug: "pachet-detergent-balsam-alpina-parfum-calgon",
    title: "PACHET · 5L Detergent Lavandă + 5L Balsam Leno Blue + 5L Detergent Pădure Alpină",
    short: "10L detergent + 5L balsam + Parfum Rufe + Calgon CADOU",
    price: 149.99,
    oldPrice: 269,
    discount: 44,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/cezi743w_IMG-20260822-WA0002.jpg",
    badge: "PACHET COMPLET",
    highlights: [
      "5L Detergent Lavandă + 5L Detergent Pădure Alpină (10L total)",
      "5L Balsam Premium Leno Blue Kassic",
      "CADOU: Parfum Concentrat de Rufe",
      "CADOU: Calgon anticalcar pentru mașina de spălat",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Combinația perfectă: 10 litri de detergent lichid concentrat în 2 arome (Lavandă și Pădure Alpină), plus 5 litri de balsam premium Leno Blue Kassic pentru rufe moi, catifelate și proaspete. Bonus 100ml de parfum concentrat de rufe pentru intensitate maximă, plus 150g Calgon anticalcar pentru protecția mașinii de spălat. Peste 200 de spălări cu detergent + peste 200 de spălări cu balsam. Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p17",
    slug: "pachet-xxxl-lavanda-alpine-spring-time",
    title: "PACHETUL XXXL · 5L Lavandă + 5L Alpine + 5L Spring Time",
    short: "15L detergent 3 arome + 100ml Parfum + 150g Calgon CADOU",
    price: 149.99,
    oldPrice: 269,
    discount: 44,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/3kkzypit_IMG-20260821-WA0009%281%29.jpg",
    badge: "PACHETUL XXXL",
    highlights: [
      "3 × 5L Detergent Concentrat — Lavandă · Alpine · Spring Time (15L)",
      "CADOU: 100ml Parfum Concentrat de Rufe",
      "CADOU: 150g Calgon anticalcar pentru mașina de spălat",
      "Peste 300 de spălări dintr-un singur pachet",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Pachetul XXXL cu 3 arome distincte de detergent lichid concentrat, câte 5 litri fiecare (Lavandă, Alpine, Spring Time) — 15 litri de detergent profesional. Bonus 100ml de parfum concentrat pentru rufe cu miros intens și de durată, plus 150g Calgon anticalcar pentru protecția mașinii de spălat. Peste 300 de spălări la un preț imbatabil, cu transport GRATUIT oriunde în România și plată cash la curier.",
  },
  {
    id: "p10",
    slug: "pachet-xl-10l-detergent-lavanda-calgon",
    title: "Pachet XL 10L Detergent Concentrat Rufe · Lavandă + 150g Calgon CADOU",
    short: "2 × 5L Detergent Lavandă + 150g Calgon anticalcar",
    price: 99.99,
    oldPrice: 189,
    discount: 47,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/ur1kw42w_IMG-20260824-WA0009.jpg",
    badge: "CADOU Calgon 150g",
    highlights: [
      "2 × 5L Detergent Concentrat Lichid Lavandă (10L total)",
      "Miros persistent de lavandă la fiecare spălare",
      "CADOU: 150g Calgon anticalcar pentru mașina de spălat",
      "Peste 200 de spălări din același pachet",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Pachetul XL cu 10 litri de detergent concentrat lichid cu aromă intensă de lavandă. Două bidoane de 5L, formulă profesională fabricată în România, îți ajung pentru peste 200 de spălări. Rufele ies proaspete, moi și cu miros persistent de lavandă. Bonus: 150g Calgon anticalcar pentru a-ți proteja mașina de spălat. Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p11",
    slug: "pachet-xl-5l-detergent-5l-balsam-lavanda-calgon",
    title: "Pachet XL 5L Detergent Lavandă + 5L Balsam + 150g Calgon CADOU",
    short: "5L Detergent Lavandă + 5L Balsam Leno Blue + Calgon 150g",
    price: 99,
    oldPrice: 189,
    discount: 48,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/65u3bwgf_IMG-20260824-WA0010.jpg",
    badge: "CADOU Calgon 150g",
    highlights: [
      "5L Detergent Concentrat Lichid Lavandă",
      "5L Balsam de Rufe Premium Leno Blue Kassic",
      "CADOU: 150g Calgon anticalcar pentru mașina de spălat",
      "Combinația ideală: curățenie profundă + catifelare",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Pachetul XL complet — 5 litri detergent concentrat cu aromă de lavandă plus 5 litri balsam premium Leno Blue Kassic pentru rufe moi și parfumate. Combinația ideală pentru familiile care vor curățenie profundă și catifelare de lux. Bonus: 150g Calgon anticalcar pentru mașina de spălat. Peste 100 de spălări cu detergent + peste 200 de spălări cu balsam. Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p8",
    slug: "detergent-10l-universal-concentrat",
    title: "Detergent Concentrat 3 arome 10L + 500ml GRATUIT",
    short: "10.5L la 89 lei · alegi aroma · transport gratuit",
    price: 89,
    oldPrice: 149,
    discount: 40,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/64m2cj5p_IMG-20260723-WA0014.jpg",
    badge: "Transport GRATUIT",
    variants: [
      { id: "alpine", label: "Alpine" },
      { id: "spring", label: "Spring Time" },
      { id: "lavanda", label: "Lavandă" },
    ],
    highlights: [
      "10L + 500ml GRATUIT (cantitate totală 10,5L)",
      "Substanță activă > 16% — formulă profesională",
      "* Alege aroma: Alpine · Spring Time · Lavandă",
      "Eficient la temperaturi joase · scoate petele · rufe albe strălucitoare",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Detergent lichid concentrat universal pentru rufe, formulă profesională cu peste 16% substanță activă. Un bidon de 10 litri plus 500ml BONUS (total 10,5L) îți ajunge pentru sute de spălări. Eficient inclusiv la temperaturi joase, scoate petele dificile și readuce strălucirea rufelor albe. Poți alege aroma preferată la comandă: Alpine (fresh de munte), Spring Time (primăvară) sau Lavandă (relaxant). Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p9",
    slug: "pachet-3-parfumuri-esentiale-rufe",
    title: "Pachet 3 Parfumuri Esențiale pentru Rufe · Argan · Spring Time · Musk & Talk",
    short: "3 × 150ml esențe concentrate FĂRĂ APĂ · miros intens",
    price: 99,
    oldPrice: 180,
    discount: 45,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/xmg6ku02_IMG-20260817-WA0032.jpg",
    badge: "FĂRĂ APĂ · 0% AQUA",
    highlights: [
      "3 sticle × 150ml — Argan · Spring Time · Musk & Talk",
      "Formulă CONCENTRATĂ fără apă (0% aqua) — miros intens și de durată",
      "Se aplică 10ml odată cu balsamul de rufe",
      "Perfect pentru cei care iubesc rufele parfumate zile la rând",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Trei esențe de parfum pentru rufe, formulă profesională concentrată fără apă (0% aqua) — asta înseamnă doar molecule de parfum pur. Se aplică 10ml odată cu balsamul de rufe și îți lasă rufele parfumate intens timp de zile întregi. Pachetul include 3 sticle de 150ml cu 3 arome distincte: Argan (elegant, cald), Spring Time (floral, proaspăt), Musk & Talk (senzual, dulce). Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p15",
    slug: "pachet-curatenie-completa-3x5l-cadouri",
    title: "PACHET CURĂȚENIE COMPLETĂ · 5L Pardoseli + 5L Baie + 5L Tapițerii",
    short: "3 × 5L curățenie profesională + Calgon și Parfum de Rufe CADOU",
    price: 149.99,
    oldPrice: 299,
    discount: 50,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/z40h9n7l_IMG-20260902-WA0005.jpg",
    badge: "CURĂȚENIE COMPLETĂ",
    highlights: [
      "5L Detergent superparfumat pentru pardoseli",
      "5L Detergent acid gel pentru baie",
      "5L Detergent tapițerii și covoare",
      "CADOU: Calgon anticalcar + Parfum de Rufe",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Pachetul de curățenie completă pentru casa ta — tot ce ai nevoie într-un singur colet. Include 15 litri de detergenți profesionali specializați: 5L detergent superparfumat pentru pardoseli (curățare intensă și miros de durată), 5L detergent acid gel special pentru baie (îndepărtează calcarul și rugina), 5L detergent pentru tapițerii și covoare (reînnoiește textilele și hainele delicate). Bonus: Calgon anticalcar pentru mașina de spălat și un parfum de rufe. Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p18",
    slug: "pachet-auto-totul-pentru-masina-ta",
    title: "TOTUL PENTRU MAȘINA TA",
    short: "5L Spumă Activă + 1L Ceară + 1L Anvelope + 100ml Hidrofobizant CADOU",
    price: 129.99,
    oldPrice: 200,
    discount: 35,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/hhzpptcg_IMG-20260904-WA0036.jpg",
    badge: "TRANSPORT GRATUIT",
    highlights: [
      "5L Spumă Activă Concentrată — 150 spălări",
      "1L Ceară Auto Super Cold Wax — protecție și strălucire",
      "1L Soluție Anvelope — reda culoarea și le protejează",
      "CADOU: 100ml Hidrofobizant Parbriz — apa nu se mai lipește de geam",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Pachet complet pentru îngrijirea profesională a mașinii tale. Include 5L spumă activă ultra-concentrată (formulă TRUCK 1%, până la 150 de spălări), 1L ceară auto premium Super Cold Wax pentru strălucire de durată și protecție împotriva agenților atmosferici, 1L soluție întreținere anvelope care le readuce culoarea neagră intensă și le protejează de crăpare. CADOU 100ml hidrofobizant pentru parbriz care împinge apa astfel încât nu se mai formează picături pe geam în timpul mersului — vizibilitate excelentă pe ploaie. Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p19",
    slug: "spuma-incaltaminte-parfum-concentrat",
    title: "SPUMĂ CONCENTRATĂ PENTRU ÎNCĂLȚĂMINTE",
    short: "1L Spa Shoes Ultra Cleaner + 100ml Parfum + 2 Lavete CADOU",
    price: 59.99,
    oldPrice: 85,
    discount: 29,
    image:
      "https://customer-assets-jt897jd0.emergentagent.net/job_eco-clean-store-1/artifacts/85izn4j8_IMG-20260904-WA0032.jpg",
    badge: "CADOU 2 Lavete",
    highlights: [
      "1L Spumă Concentrată pentru toate tipurile de încălțăminte",
      "Curăță, scoate petele, dă strălucire — nu atacă și nu degradează",
      "100ml Parfum Concentrat 0% apă — miros de nou care persistă zile întregi",
      "CADOU: 2 lavete profesionale",
      "Transport GRATUIT · plată cash la livrare",
    ],
    description:
      "Spumă concentrată specială pentru toate tipurile de încălțăminte: piele, piele întoarsă, textil, sneakers. Curăță în profunzime, scoate petele și readuce strălucirea, fără să atace sau să degradeze materialul. Formulă antistatică cu protecție de durată. La pachet primești și un parfum concentrat de 100ml cu 0% conținut de apă — doar molecule pure de parfum, aplici câțiva stropi și lași un miros de nou și proaspăt care persistă zile întregi. CADOU: 2 lavete profesionale pentru aplicare și lustruit. Transport GRATUIT oriunde în România, plată cash la curier.",
  },
  {
    id: "p3",
    slug: "detergent-rufe-5l-lavanda",
    title: "Detergent Rufe 5L – Lavanda",
    short: "Curățenie profundă cu miros relaxant de lavandă",
    price: 59.99,
    oldPrice: 100,
    discount: 31,
    image: "https://detergentidegresanti.ro/wp-content/uploads/2026/03/Detergent-de-Rufe-5-litri-Lavanda-800x800.jpg.avif",
    badge: "Bestseller",
    highlights: [
      "Aromă fină de lavandă",
      "Peste 100 de spălări",
      "Formulă concentrată",
      "Potrivit pentru toate tipurile de rufe",
    ],
    description:
      "Detergentul nostru cu aromă de lavandă combină eficiența unei formule profesionale concentrate cu un parfum delicat și relaxant. Ideal pentru hainele de zi cu zi și lenjerie de pat, lasă rufele moi, curate și parfumate. Un bidon de 5 litri îți ajunge pentru peste 100 de spălări.",
  },
  {
    id: "p4",
    slug: "detergent-rufe-5l-glamour",
    title: "Detergent 5L – Glamour",
    short: "Formulă premium pentru rufe care strălucesc",
    price: 59.99,
    oldPrice: 100,
    discount: 31,
    image: "https://detergentidegresanti.ro/wp-content/uploads/2026/03/Detergent-de-rufe-5L-Glamour-800x800.jpg",
    badge: "Premium",
    highlights: [
      "Parfum luxuriant Glamour",
      "Curățare profundă",
      "Protejează culorile",
      "5L concentrat",
    ],
    description:
      "Linia Glamour este pentru cei care vor ca hainele lor să atragă privirile. Formula premium oferă o curățare profundă, păstrează intensitatea culorilor și lasă un parfum sofisticat care durează zile întregi după spălare.",
  },
  {
    id: "p5",
    slug: "detergent-rufe-5l-alpine-forest",
    title: "Detergent de Rufe Alpine Forest – 5L",
    short: "Prospețimea pădurii alpine în hainele tale",
    price: 59.99,
    oldPrice: 100,
    discount: 31,
    image: "https://detergentidegresanti.ro/wp-content/uploads/2026/03/Detergent-de-Rufe-Alpine-Forest-5-litri-800x800.jpg",
    badge: "Fresh",
    highlights: [
      "Aromă fresh de pădure",
      "Formulă concentrată 5L",
      "Eficient la temperaturi scăzute",
      "Pentru pielea sensibilă",
    ],
    description:
      "Inspirat din aerul curat al pădurilor alpine, acest detergent îți va transforma momentul spălării într-o experiență revigorantă. Curăță eficient chiar și la 30°C, fiind potrivit pentru toate tipurile de țesături, inclusiv cele sensibile.",
  },
  {
    id: "p6",
    slug: "balsam-rufe-5l-leno-blue-kassic",
    title: "Balsam de Rufe Premium – Leno Blue Kassic – 5L",
    short: "Catifelare de lux și parfum persistent",
    price: 59.99,
    oldPrice: 120,
    discount: 38,
    image: "https://detergentidegresanti.ro/wp-content/uploads/2026/03/Balsam-de-Rufe-Leno-Blue-Kassic-5L-1-800x800.jpg",
    badge: "Lux",
    highlights: [
      "Parfum inconfundabil Leno",
      "Catifelează țesăturile",
      "Reduce electricitatea statică",
      "5L premium",
    ],
    description:
      "Balsamul premium Leno Blue Kassic catifelează fibrele, reduce încărcătura statică și lasă rufele cu un parfum elegant ce persistă timp îndelungat. Este balsamul perfect pentru cei cu standarde înalte de calitate.",
  },
];

export const getProduct = (slug) => products.find((p) => p.slug === slug);
